/**
 * ScannerSetupHelp (Jun-2026, User-Wunsch) — dezenter, ausklappbarer Hinweis,
 * wie ein fester Scanner mit dem Lieferschein-Scan genutzt werden kann.
 * Foto/Kamera + PDF-Upload funktionieren ohne Zusatzsoftware; für einen
 * vorkonfigurierten Scanner gibt es Selbst-Einrichtungs-Optionen mit Downloads.
 */
import { useState } from "react";
import { HelpCircle, Download, ChevronDown, Printer } from "lucide-react";

export default function ScannerSetupHelp({ onConfigureScanner, deskScannerName }) {
    const [open, setOpen] = useState(false);
    return (
        <div className="mt-2" data-testid="scanner-setup-help">
            <button onClick={() => setOpen((v) => !v)} className="text-[11px] text-gray-500 hover:text-gray-700 inline-flex items-center gap-1" data-testid="scanner-help-toggle">
                <HelpCircle className="w-3 h-3" /> Eigenen Scanner einrichten{deskScannerName ? ` (hinterlegt: ${deskScannerName})` : ""}
                <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
            </button>
            {open && (
                <div className="mt-2 text-[11px] text-gray-600 bg-gray-50 border border-gray-200 rounded-sm p-3 leading-relaxed space-y-2" data-testid="scanner-help-content">
                    <p>
                        <b>Mit PC scannen (empfohlen):</b> Einmalig die{" "}
                        <a href="/TwoWheels-ScanBridge.cmd" download className="text-indigo-600 font-bold underline inline-flex items-center gap-0.5" data-testid="scanner-bridge-download">
                            TwoWheels Scan-Bridge (Windows) <Download className="w-3 h-3" />
                        </a>{" "}
                        herunterladen und per Doppelklick (bei SmartScreen: „Trotzdem ausführen") starten. Danach steuert der Button <b>„Mit PC scannen"</b> den angeschlossenen Scanner (USB oder Netzwerk mit Windows-Treiber, z. B. Brother) direkt an — das Dokument geht ohne Umwege in den KI-Scan. Die Bridge richtet sich automatisch im Windows-Autostart ein.
                    </p>
                    <p><b>Mit Handy scannen:</b> Beleg mit Handy/Webcam fotografieren – die KI erkennt die Positionen automatisch, ganz ohne Zusatzsoftware.</p>
                    <p><b>WLAN-/Netzwerk-Scanner (eSCL/AirPrint):</b> Am Gerät auf „Scan in E-Mail" oder „Scan in Ordner" stellen, die Datei dort abholen und über „Datei hochladen" übernehmen.</p>
                    {onConfigureScanner && (
                        <button type="button" onClick={onConfigureScanner}
                            className="inline-flex items-center gap-1 font-bold text-gray-700 border border-gray-300 rounded-sm px-2 py-1 bg-white hover:border-gray-500"
                            data-testid="desk-scanner-config-btn">
                            <Printer className="w-3 h-3" /> Tischscanner hinterlegen / ändern (einmalig)
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
